import { Component, EventEmitter, Input, Output, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { ControlValueAccessor, DefaultValueAccessor, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { IconComponent } from '@libs/components/icons';
import { TextInputModel } from '@libs/form/models';
import { ErrorDirective, InputAttributesDirective, InputValidatorsDirective } from '../../../directives';
import { InputBaseComponent } from '../../../models';
import { FormInputDescriptionComponent } from '../../description';
import { InputProviderFactory } from '../ng-input-provider';

@Component({
  selector: 'ui-form-text',
  templateUrl: './text.component.html',
  providers: [
    ...InputProviderFactory.getProviders(TextComponent),
  ],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    ReactiveFormsModule,
    InputAttributesDirective,
    InputValidatorsDirective,
    ErrorDirective,
    IconComponent,
    FormInputDescriptionComponent,
  ],
})
export class TextComponent extends InputBaseComponent {
  @Input()
  public data!: TextInputModel;

  @ViewChild(DefaultValueAccessor, { static: true })
  public valueAccessor!: ControlValueAccessor;

  @Output()
  public prefixClick: EventEmitter<MouseEvent> = new EventEmitter<MouseEvent>();

  @Output()
  public suffixClick: EventEmitter<MouseEvent> = new EventEmitter<MouseEvent>();
}
